// extracted by mini-css-extract-plugin
module.exports = {"root":"Member_root__3peD-","statusLabel":"Member_statusLabel__PhSAx"};